<template>  
   
        <v-card>
            <v-card-title>
                <h4 class="headline ma-0 grey--text text--darken-2">Fehlerübersicht</h4>
            </v-card-title>
            <v-list>                      
                <v-list-tile 
                    v-on:click="preFilterFirmen(err.firmen_marken)"
                >
                    <v-list-tile-content>
                        <v-badge>
                            <span slot="badge">{{ err.firmen_marken.length }}</span>
                            <span >Firmen ohne Marken</span>
                        </v-badge>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile 
                    v-on:click="preFilterFirmen(err.firmen_adressen)"
                >
                    <v-list-tile-content>
                        <v-badge>
                            <span slot="badge">{{ err.firmen_adressen.length }}</span>
                            <span >Firmen ohne Adressen</span>
                        </v-badge>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile 
                    v-on:click="preFilterFirmen(err.firmen_created)"
                >
                    <v-list-tile-content>
                        <v-badge >
                            <span slot="badge">{{ err.firmen_created.length }}</span>
                            <span >Firmen ohne Created Datum</span>
                        </v-badge>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile 
                    v-on:click="preFilterFirmen(err.firmen_updated)"
                >
                    <v-list-tile-content>
                        <v-badge>
                            <span slot="badge">{{ err.firmen_updated.length }}</span>
                            <span >Firmen ohne Updated Datum</span>
                        </v-badge>
                    </v-list-tile-content>
                </v-list-tile>
               <v-divider class="my-2"></v-divider>
               <v-list-tile 
                    v-on:click="preFilterMarken(err.marken_firmen)"
                >
                    <v-list-tile-content>
                        <v-badge>
                            <span slot="badge">{{ err.marken_firmen.length }}</span>
                            <span >Marken ohne Firmen</span>
                        </v-badge>
                    </v-list-tile-content>
                </v-list-tile>
               <v-list-tile 
                    v-on:click="preFilterMarken(err.marken_types)"
                >
                    <v-list-tile-content>
                        <v-badge>
                            <span slot="badge">{{ err.marken_types.length }}</span>
                            <span >Marken ohne Typen</span>
                        </v-badge>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile 
                    v-on:click="preFilterMarken(err.marken_warengruppen)"
                >
                    <v-list-tile-content>
                        <v-badge>
                            <span slot="badge">{{ err.marken_warengruppen.length }}</span>
                            <span >Marken ohne Warenguppen</span>
                        </v-badge>
                    </v-list-tile-content>
                </v-list-tile>
               <v-list-tile 
                    v-on:click="preFilterMarken(err.marken_logos)"
                >
                    <v-list-tile-content>
                        <v-badge>
                            <span slot="badge">{{ err.marken_logos.length }}</span>
                            <span >Marken ohne Logos</span>
                        </v-badge>
                    </v-list-tile-content>
                </v-list-tile>
               <v-list-tile 
                    v-on:click="preFilterMarken(err.marken_created)"
                >
                    <v-list-tile-content>
                        <v-badge>
                            <span slot="badge">{{ err.marken_created.length }}</span>
                            <span >Marken ohne Created Datum</span>
                        </v-badge>
                    </v-list-tile-content>
                </v-list-tile>
               <v-list-tile 
                    v-on:click="preFilterMarken(err.marken_updated)"
                >
                    <v-list-tile-content>
                        <v-badge>
                            <span slot="badge">{{ err.marken_updated.length }}</span>
                            <span >Marken ohne Updated Datum</span>
                        </v-badge>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile 
                    v-on:click="preFilterMarken(err.marken_dummylogo)"
                >
                    <v-list-tile-content>
                        <v-badge>
                            <span slot="badge">{{ err.marken_dummylogo.length }}</span>
                            <span >Marken mit Dummy Logo</span>
                        </v-badge>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list>
        </v-card>                
    
</template>

<script>



export default {
    
    props: [
        'err'
    ],
    methods: {
        preFilterMarken: function(arr) {
            this.$emit("preFilterMarken", arr);
        },
        preFilterFirmen: function(arr) {
            this.$emit("preFilterFirmen", arr);
        }
    }
    

    
}
</script>

<style>
    
    
</style>




// WEBPACK FOOTER //
// errorCard.vue?3c5e88bc